import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    StyledManagementCardBodySlot,
    StyledManagementCardFooterSlot,
    StyledManagementCardGridWrapper,
    StyledManagementCardHeaderSlot,
} from "./styles";

const ManagementCardPlaceholder = (): React.ReactElement => {
    return (
        <StyledManagementCardGridWrapper data-automation="management-card-placeholder">
            <StyledManagementCardHeaderSlot>
                <Flex justifyContent="space-between">
                    <PixelPlaceholderLoader
                        width="85%"
                        height="24px"
                    />
                    <PixelPlaceholderLoader
                        width="24px"
                        height="24px"
                    />
                </Flex>
            </StyledManagementCardHeaderSlot>

            <StyledManagementCardBodySlot>
                <Flex
                    flexDirection="column"
                    gap="4px"
                >
                    <PixelPlaceholderLoader
                        width="100%"
                        height="16px"
                    />
                    <PixelPlaceholderLoader
                        width="100%"
                        height="16px"
                    />
                    <PixelPlaceholderLoader
                        width="70%"
                        height="16px"
                    />
                </Flex>
            </StyledManagementCardBodySlot>

            <StyledManagementCardFooterSlot>
                <PixelPlaceholderLoader
                    width="100%"
                    height="36px"
                />
            </StyledManagementCardFooterSlot>
        </StyledManagementCardGridWrapper>
    );
};

export default ManagementCardPlaceholder;
